import { IconButton } from '../IconButton/IconButton.es.js';
import styled from 'styled-components';

const Action = styled(IconButton).attrs(() => ({
  label: "",
  variant: "subtle",
  isRounded: true,
  size: "sm",
  hideTooltip: true
}))``;
Action.displayName = "FeatureCard.Action";

export { Action };
//# sourceMappingURL=FeatureCardAction.es.js.map
